/**
 * @typedef {String} module:EventService.EventTypeEnum
 * @readonly
 * @description The list of values that the type property of an event can have
 * @property {String} video "VIDEO"
 * @property {String} mp4 "MOTION_MP4" Deprecated - use VIDEO
 * @property {String} fmp4 "MOTION_FMP4" Deprecated - use VIDEO
 * @property {String} mjpeg "MOTION_MJPEG" Deprecated - use IMAGE_SET
 * @property {String} imageSet "IMAGE_SET"
 * @property {String} image "IMAGE"
 * @property {String} motionDataOnly "MOTION_DATAONLY"
 * @property {String} doorbell "DOORBELL"
 * @property {String} audioAlert "AUDIO_DATAONLY"
 * @property {String} log "LOG_ENTRY"
 * @property {String} highlight "HIGHLIGHT_VIDEO"
 * @property {String} blank "blank"
 * @property {String} camLowBattery "CAM_LOW_BATT"
 * @property {String} camShutdown "CAM_SHUTDOWN"
 * @property {String} camOnline "CAM_BACK_ONLINE"
 * @property {String} audioTrigVid "AUDIO_TRIG_VID"
 * @property {String} timelapseVid "TIMELAPSE_VID"
 * @property {String} timelapsePic "TIMELAPSE_PIC"
 * @property {String} userVid "USER_VID"
 * @property {String} userPic "USER_PIC"
 * @property {String} personCheckin "PERSON_CHECKIN"
 * @property {String} snapshotPic "SNAPSHOT_PIC"
 * @property {String} gdOpen "GD_OPEN"
 * @property {String} gdClose "GD_CLOSE"
 * @property {String} gvEnter "G_V_ENTER"
 * @property {String} gvExit "G_V_EXIT"
 * @property {String} sensorNew "SENSOR_NEW"
 * @property {String} sensorChange "SENSOR_CHANGE"
 * @property {String} sensorOnline "SENSOR_ONLINE"
 * @property {String} sensorOffline "SENSOR_OFFLINE"
 * @property {String} callButton "CALL_BUTTON"
 * @property {String} pinUsed "PIN_USED"
 * @property {String} invalidPin "INVALID_PIN"
 * @property {String} fwUpgrade "FW_UPGRADE"
 * @property {String} capResCall "CAP_RES_CALL"
 * @property {String} capResOpen "CAP_RES_OPEN"
 * @property {String} capResNact "CAP_RES_NACT"
 */
const EventTypeEnum = Object.freeze({
    video: 'VIDEO',
    mp4: 'MOTION_MP4', // Deprecated - use VIDEO
    fmp4: 'MOTION_FMP4', // Deprecated - use VIDEO
    mjpeg: 'MOTION_MJPEG', // Deprecated - use IMAGE_SET
    imageSet: 'IMAGE_SET',
    image: 'IMAGE',
    motionDataOnly: 'MOTION_DATAONLY',
    doorbell: 'DOORBELL',
    audioAlert: 'AUDIO_DATAONLY',
    log: 'LOG_ENTRY',
    highlight: 'HIGHLIGHT_VIDEO',
    blank: 'blank',
    camLowBattery: 'CAM_LOW_BATT',
    camShutdown: 'CAM_SHUTDOWN',
    camOnline: 'CAM_BACK_ONLINE',
    audioTrigVid: 'AUDIO_TRIG_VID',
    timelapseVid: 'TIMELAPSE_VID',
    timelapsePic: 'TIMELAPSE_PIC',
    userVid: 'USER_VID',
    userPic: 'USER_PIC',
    personCheckin: 'PERSON_CHECKIN',
    snapshotPic: 'SNAPSHOT_PIC',
    gdOpen: 'GD_OPEN',
    gdClose: 'GD_CLOSE',
    gvEnter: 'G_V_ENTER',
    gvExit: 'G_V_EXIT',
    sensorNew: 'SENSOR_NEW',
    sensorChange: 'SENSOR_CHANGE',
    sensorOnline: 'SENSOR_ONLINE',
    sensorOffline: 'SENSOR_OFFLINE',
    callButton: 'CALL_BUTTON',
    pinUsed: 'PIN_USED',
    invalidPin: 'INVALID_PIN',
    fwUpgrade: 'FW_UPGRADE',
    capResCall: 'CAP_RES_CALL',
    capResOpen: 'CAP_RES_OPEN',
    capResNact: 'CAP_RES_NACT'
});

export default EventTypeEnum;
